import { render, staticRenderFns } from "./BreachPaymentsPlan.vue?vue&type=template&id=022dad71&"
import script from "./BreachPaymentsPlan.vue?vue&type=script&lang=js&"
export * from "./BreachPaymentsPlan.vue?vue&type=script&lang=js&"
import style0 from "./BreachPaymentsPlan.vue?vue&type=style&index=0&id=022dad71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports